import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const SpriteScrollAnimation = () => {
    const scrollContainerRef = useRef(null);
    const spriteContainerRef = useRef(null);
    const imagesRef = useRef([]);
    const textRef = useRef(null);

    // Create array of image paths
    const imagePaths = Array.from({ length: 7 }, (_, i) => `/paper/${i + 1}.png`);

    useEffect(() => {
        // Set initial states - hide all images except first and hide text
        imagesRef.current.forEach((img, index) => {
            if (img) {
                gsap.set(img, { opacity: index === 0 ? 1 : 0 });
            }
        });

        if (textRef.current) {
            gsap.set(textRef.current, { opacity: 0 });
        }

        // Create scroll-triggered animation
        ScrollTrigger.create({
            trigger: scrollContainerRef.current,
            start: "top center",
            end: "bottom bottom",
            scrub: 1,
            onUpdate: (self) => {
                const progress = self.progress;
                const imageIndex = Math.floor(progress * 6.99); // 0-6 range

                // Animate opacity for each image
                imagesRef.current.forEach((img, index) => {
                    if (img) {
                        const targetOpacity = index === imageIndex ? 1 : 0;
                        gsap.to(img, {
                            opacity: targetOpacity,
                            duration: 0.3,
                            ease: "power2.out"
                        });
                    }
                });

                // Show text when last image (index 6) is visible
                if (textRef.current) {
                    const textOpacity = imageIndex === 6 ? 1 : 0;
                    gsap.to(textRef.current, {
                        opacity: textOpacity,
                        duration: 0.5,
                        ease: "power2.out"
                    });
                }
            }
        });

        // Cleanup
        return () => {
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
        };
    }, []);

    return (
        <div className="min-h-screen">
            {/* Normal scrollable section with 200vh height */}
            <div ref={scrollContainerRef} className="h-[150vh] relative">
                {/* Sticky sprite container that stays centered on all devices */}
                <div className="sticky top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-40 md:w-96 h-40 md:h-96  z-10">
                    <div
                        ref={spriteContainerRef}
                        className="w-full h-full relative flex items-center justify-center"
                    >
                        {imagePaths.map((path, index) => (
                            <img
                                key={index}
                                ref={el => imagesRef.current[index] = el}
                                src={path}
                                alt={`Sprite ${index + 1}`}
                                className="absolute inset-0 w-full h-full object-contain max-md:scale-[2.4]"
                            />
                        ))}

                        {/* Text overlay on last image */}
                        <div
                            ref={textRef}
                            className="absolute inset-0 flex items-center justify-center rounded-lg p-4 sm:p-8 w-full"
                            style={{
                                backgroundImage: 'url(/paper/7.png)',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat'
                            }}
                        >
                            <div className="text-center w-full ">
                                <p className="text-gray-800 w-full text-sm md:text-base sm:text-lg leading-relaxed mb-4 sm:mb-6">
                                    We convert business visions<br />
                                    and customer needs<br />
                                    into enjoyable experiences.
                                </p>
                                <div className="md:border-t border-gray-400  md:pt-6">
                                    <p className="text-gray-600 hidden md:block text-xs sm:text-sm tracking-wider mb-1 sm:mb-2">CONTACT</p>
                                    <p className="text-gray-800 hidden md:block text-xs md:text-lg font-medium mb-0 md:mb-3">info@boldedgemedia.com</p>
                                    <a
                                        href="/contact"
                                      
                                    >
                                        <button   className="orange py-0 text-xs px-2 w-fit block mx-auto">
                                            Book a call
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default SpriteScrollAnimation;